import React, { useEffect } from "react";
import contactimgleft from '../assets/images/contactimgleft.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
const Contactus = () => {
        useEffect(() => {
                            AOS.init();
                            AOS.refresh();
                        }, [])
    return (
        <div>

            <section className="contact-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Contact Us</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                        Contact Us</p>
                </div>
            </section>
            <section className="contact-content-details-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-7 col-lg-7">
                            <p className="ab-depart-subheading">Need Any Helps ?</p>
                            <p className="home-about-head ">Contact For Information</p>
                            <p className="museum-main-para ">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium totam
                                rem aperiam eaque ipsa quae abillo inventore veritatis et quasi architecto</p>
                            <div className="row   text-center">
                                <div className="col-12 col-md-4 " data-aos="fade-up" data-aos-delay="300" data-aos-duration="300">
                                    <div className="contact-center-details-sec">
                                    <i class="fa fa-map-marker  contact-details-icon  text-center" aria-hidden="true"></i>
                                    <p className="contact-center-details-head text-center">Locations </p>
                                    <p className="  contact-center-details-para text-center">
                                    55 Main Street, 2nd < br />
                                    Block, New York
                                    </p>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 " data-aos="fade-up" data-aos-delay="600" data-aos-duration="300">
                                    <div className="contact-center-details-sec">
                                    <i class="fa fa-envelope  contact-details-icon  text-center" aria-hidden="true"></i>
                                    <p className="contact-center-details-head text-center"> Email Us </p>
                                    <p className="  contact-center-details-para text-center">
                                    support@gmail.com< br />
                                    infocoach.net
                                    </p>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 " data-aos="fade-up" data-aos-delay="900" data-aos-duration="300">
                                    <div className="contact-center-details-sec">
                                    <i class="fa fa-volume-control-phone  contact-details-icon  text-center" aria-hidden="true"></i>
                                    <p className="contact-center-details-head text-center">Locations </p>
                                    <p className="  contact-center-details-para text-center">
                                    55 Main Street, 2nd < br />
                                    Block, New York
                                    </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-12 col-md-5 ">
<img src={contactimgleft} className="contact-img-left" />
                        </div>
                    </div>
                </div>
            </section>

<section className="contact-map-section">
    <div className="contactmap-design">
    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d79125.73338274812!2d-0.400436!3d51.702316!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48764353fe1ff4bf%3A0x8a9aa6b19e6e428b!2sBerkhamsted%20Castle!5e0!3m2!1sen!2sus!4v1744567472923!5m2!1sen!2sus" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
</section>






        </div>

    )
}
export default Contactus